import { useState, useEffect } from 'react'
import { supabase } from '../supabaseClient'
import { conflictCheckedUpdate } from '../utils'

export function useContacts(session, showToast) {
  const [contacts, setContacts] = useState([])

  useEffect(() => {
    if (!session) return
    supabase
      .from("contacts")
      .select("*")
      .then(({ data }) => {
        if (data) {
          setContacts(data.map(c => ({
            id: c.id,
            supabaseId: c.id,
            type: c.type,
            name: c.name,
            company: c.company || "",
            phone: c.phone || "",
            email: c.email || "",
            licenseNumber: c.license_number || "",
            wcPolicy: c.wc_policy || "",
            wcExpires: c.wc_expires || "",
            updatedAt: c.updated_at || null,
          })))
        }
      })
  // eslint-disable-next-line react-hooks/exhaustive-deps -- stabilize: only re-fetch on user change, not token refresh
  }, [session?.user?.id])

  async function saveContactToSupabase(contact) {
    const { data: { user } } = await supabase.auth.getUser()
    const row = {
      user_id: user.id,
      type: contact.type,
      name: contact.name,
      company: contact.company || null,
      phone: contact.phone || null,
      email: contact.email || null,
      license_number: contact.licenseNumber || null,
      wc_policy: contact.wcPolicy || null,
      wc_expires: contact.wcExpires || null,
    }
    if (contact.supabaseId) {
      const result = await conflictCheckedUpdate(supabase, "contacts", contact.supabaseId, row, contact.updatedAt)
      if (result.conflict) {
        showToast("Contact was modified by another user. Refreshing…", "warning")
        const { data } = await supabase.from("contacts").select("*")
        if (data) setContacts(data.map(c => ({
          id: c.id, supabaseId: c.id, type: c.type, name: c.name,
          company: c.company || "", phone: c.phone || "", email: c.email || "",
          licenseNumber: c.license_number || "", wcPolicy: c.wc_policy || "",
          wcExpires: c.wc_expires || "", updatedAt: c.updated_at || null,
        })))
        return
      }
      if (!result.ok) { console.error("Failed to update contact:", result.error); showToast("Failed to save contact. Please try again.", "error"); }
    } else {
      const { data, error } = await supabase.from("contacts").insert(row).select().single()
      if (error) { console.error("Failed to insert contact:", error); showToast("Failed to save contact. Please try again.", "error"); return null; }
      return data.id
    }
  }

  async function deleteContactFromSupabase(supabaseId) {
    const { error } = await supabase.from("contacts").delete().eq("id", supabaseId)
    if (error) { console.error("Failed to delete contact:", error); showToast("Failed to delete contact. Please try again.", "error"); }
  }

  return {
    contacts, setContacts,
    saveContactToSupabase,
    deleteContactFromSupabase,
  }
}
